import type { ManagedUser, ManagedRole, ManagedTenant } from "./types";
import { ROLES } from "@/data/RoleContext";
import { CAPABILITY_REGISTRY } from "./registry";

const NOW_ISO = "2026-01-01T00:00:00.000Z";

export const SEED_TENANTS: ManagedTenant[] = [
  {
    id: "tenant-001",
    name: "Koredor HQ",
    slug: "koredor-hq",
    status: "active",
    modeProfile: "internal",
    environment: "internal",
    createdAt: NOW_ISO,
    updatedAt: NOW_ISO,
    userCount: 6,
    capabilityOverrides: {},
    metadata: { region: "us", plan: "internal" },
  },
  {
    id: "tenant-002",
    name: "Acme Contractors",
    slug: "acme-contractors",
    status: "active",
    modeProfile: "contractor_lite",
    environment: "production",
    createdAt: NOW_ISO,
    updatedAt: NOW_ISO,
    userCount: 4,
    capabilityOverrides: {},
    metadata: { region: "us", plan: "contractor_lite" },
  },
  {
    id: "tenant-003",
    name: "Summit Home Services",
    slug: "summit-home-services",
    status: "trial",
    modeProfile: "pilot",
    environment: "pilot",
    createdAt: NOW_ISO,
    updatedAt: NOW_ISO,
    userCount: 4,
    capabilityOverrides: {},
    metadata: { region: "us", plan: "pilot" },
  },
];

function makeUser(
  id: string,
  role: ManagedUser["role"],
  tenantId: string,
  firstName: string,
  lastName: string,
  status: ManagedUser["status"] = "active"
): ManagedUser {
  const displayName = `${firstName} ${lastName}`;
  return {
    id,
    email: `${id}@example.com`,
    displayName,
    firstName,
    lastName,
    role,
    status,
    tenantId,
    createdAt: NOW_ISO,
    updatedAt: NOW_ISO,
    capabilityOverrides: {},
    metadata: {},
  };
}

export const SEED_USERS: ManagedUser[] = [
  makeUser("usr-001", "super_admin", "tenant-001", "System", "Admin"),
  makeUser("usr-002", "owner", "tenant-001", "Olivia", "Owner"),
  makeUser("usr-003", "ops_manager", "tenant-001", "Oscar", "Ops"),
  makeUser("usr-004", "sales", "tenant-001", "Sally", "Sales"),
  makeUser("usr-005", "installer", "tenant-001", "Ivan", "Installer"),
  makeUser("usr-006", "cfo", "tenant-001", "Cory", "Finance"),

  makeUser("usr-007", "admin", "tenant-002", "Ada", "Admin"),
  makeUser("usr-008", "warehouse_manager", "tenant-002", "Wade", "Warehouse"),
  makeUser("usr-009", "subcontractor", "tenant-002", "Sam", "Sub"),
  makeUser("usr-010", "sales", "tenant-002", "Mia", "Manager"),

  makeUser("usr-011", "finance_manager", "tenant-003", "Fiona", "Manager"),
  makeUser("usr-012", "bookkeeper", "tenant-003", "Ben", "Bookkeeper"),
  makeUser("usr-013", "procurement_manager", "tenant-003", "Priya", "Procurement"),
  makeUser("usr-014", "inventory_manager", "tenant-003", "Inez", "Inventory"),
];

export function buildManagedRoles(users: ManagedUser[] = []): ManagedRole[] {
  return ROLES.map(r => {
    const roleCaps = CAPABILITY_REGISTRY
      .filter(c => c.rolesAllowed.includes(r.key))
      .map(c => c.id);
    return {
      id: r.key,
      label: r.label,
      description: r.description,
      isSystem: true,
      capabilityAccess: roleCaps,
      userCount: users.filter(u => u.role === r.key).length,
    };
  });
}
